import { Popover as AntdPopover } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const Popover = styled(AntdPopover)`
  padding: 5px;
`;

export const GlobalStyle = createGlobalStyle`
   .ant-popover-placement-right > .ant-popover-content > .ant-popover-arrow {
    border-left-color: rgba(0, 0, 0, 0.75) !important;
    border-bottom-color: rgba(0, 0, 0, 0.75) !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
  }

  .ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow,
  .ant-popover-placement-bottomLeft > .ant-popover-content > .ant-popover-arrow,
  .ant-popover-placement-bottomRight > .ant-popover-content > .ant-popover-arrow {
    border-top-color: rgba(0, 0, 0, 0.75) !important;
    border-left-color: rgba(0, 0, 0, 0.75) !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
  }

  .ant-popover-placement-left > .ant-popover-content > .ant-popover-arrow {
    border-right-color: rgba(0, 0, 0, 0.75) !important;
    border-bottom-color: rgba(0, 0, 0, 0.75) !important;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
  }
`;
